import useAuth from "./useAuth";
import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

export default function ProtectedRoutes({ children, allowed }) {
    const { auth } = useAuth();
    const location = useLocation();

    if (!auth.userName) {
        // user not authenticated
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // user allowed to access this route
    return children;
}